import Keymap from "./keymap"

const removeAllMarks = (event, editor) => {
  editor.value.marks.forEach(mark => {
    editor.removeMark(mark)
  })
}

export default () => [
  Keymap({
    "mod+shift+x": removeAllMarks
  })
]
